export const BANK_TRANSFER_TRACKING_FEATURE_NAME = 'bank transfer';

export const BANK_TRANSFER_TRACKING_SOURCE_TYPE_MYQIMA = 'payments';

export const BANK_TRANSFER_TRACKING_SOURCE_TYPE_PORTAL = 'payment portal';
